import { render, staticRenderFns } from "./formQtwj.vue?vue&type=template&id=788c5214&scoped=true&"
import script from "./formQtwj.vue?vue&type=script&lang=js&"
export * from "./formQtwj.vue?vue&type=script&lang=js&"
import style0 from "./formQtwj.vue?vue&type=style&index=0&id=788c5214&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c5214",
  null
  
)

export default component.exports